import type { RawPageConfig } from '#shared/types/page-config'
import curabox from '#shared/configs/curabox'
import services from '#shared/configs/services'
import local from '#shared/configs/local'

const normalizeHeaders = (headers: Record<string, string | string[] | undefined>) => {
  return Object.fromEntries(Object.entries(headers).map(([key, value]) => ([key.toLowerCase(), value])))
}
    
export const getPageConfig = (environment: string, hostname: string, pathname: string, headers: Record<string, string | string[] | undefined>) => {
  if (import.meta.client) {
    throw new Error('page config can only be determined by the backend.')
  }

  let configs: RawPageConfig[]
  if (environment === 'local') {
    configs = local
  } else {
    configs = [...curabox, ...services]
  }

  const config = configs.find((config) => {
    if (typeof config.domain === 'string') {
      if (config.domain !== hostname) {
        return false
      }
    } else if (Array.isArray(config.domain)) {
      if (!config.domain.includes(hostname)) {
        return false
      }
    } else if (config.domain) {
      if (!config.domain.test(hostname)) {
        return false
      }
    }

    if (config.path) {
      if (!pathname.startsWith(config.path)) {
        return false
      }
    }

    if (config.headers) {
      const headersNormalized = normalizeHeaders(headers)
      const configHeadersNormalized = normalizeHeaders(config.headers)
      for (const [key, value] of Object.entries(configHeadersNormalized)) {
        if (!(key in headersNormalized) || headersNormalized[key] !== value) {
          return false
        }
      }
    }

    return true
  })

  return config
}
